<template>
  <div>
    <nav-bar-home></nav-bar-home>
    <div class="error-page-wrapper">
      <div class="error-box-wrap">
        <div class="text-center container">
          <h1 class="heading-404">404</h1>
          <div class="error-box">
            <h3>Sorry Page Not Found</h3>
            <p>The page you are looking for does not appear to exist. Please go back or head on over our homepage to choose a new direction.</p>
            <div class="error-action clearfix">
              <router-link to="/" class="btn btn-light error-home">
                <i class="fa fa-home"></i> Go to home
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-section></footer-section>
  </div>
</template>

<script>
// import NavBarHome from '../components/NavBarHome.vue';
import NavBarHome from "@/components/NavBarHome.vue"
import FooterSection from "@/components/FooterSection.vue"

export default {
  name: 'NotFound',
  components: {
    NavBarHome,
    FooterSection,
  },
};
</script>

<style scoped>
.error-page-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 80vh;
  background-color: #f8f9fa;
}
.heading-404 {
  font-size: 120px;
  letter-spacing: 4px;
  line-height: 120px;
  font-weight: bold;
  color: #fd5b4e;
  margin-bottom: 0;
  text-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
}
.error-box {
  background: #ffffff;
  overflow: hidden;
  padding: 70px 50px 30px 50px;
  margin-top: -70px;
  margin-bottom: 30px;
}
.error-box h3 {
  margin-top: 0;
  color: #fd5b4e;
  font-size: 24px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 60px;
}
.error-box p {
  color: #6c757d;
  margin-bottom: 60px;
}
.btn.error-home {
  margin-top: 20px;
  padding: 12px 25px;
  font-size: 1rem;
  border-radius: 50px;
  background-color: #7367f0;
  color: white;
  text-decoration: none;
  transition: background-color 0.3s;
}
.btn.error-home:hover {
  background-color: #0056b3;
}
.fa-home {
  margin-right: 8px;
}
</style>
